import * as React from "react";
import {
  InputElementUnion,
  INumberInputElement,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "../common-properties-editor";
import { NumberValidationEditor } from "../number-validation-editor";

// this file is based on NumberInputEditor of form-builder
// see: https://github.com/graffer-inc/graffer-schemas/blob/70784b3c071948bd221f8268b58112603a8d87fd/libs/packages/form-builder/lib/elements/editor-pane/element-editor/editors/number-input-editor/number-input-editor.tsx

type NumberInputEditorProps = {
  element: INumberInputElement;
  onElementUpdate: (arg: InputElementUnion) => void;
};

export const NumberInputEditor: React.FC<NumberInputEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <>
        <hr />
        <NumberValidationEditor
          element={element}
          onElementUpdate={onElementUpdate}
        />
      </>
    </>
  );
};
